import { createLogger } from '@module-federation/sdk';
const logger = createLogger('[ Module Federation Data Prefetch ]');
export default logger;
